module.exports = __webpack_public_path__ + "static/image/service/pc/kitchen.jpg?dd99de35";